var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app-bar',{staticClass:"header-noauth management px-10 pt-5 pb-3"},[_c('div',{staticClass:"header-noauth-top d-flex justify-end align-center"},[_c('img',{staticClass:"shrink mr-2",attrs:{"alt":"anicom","contain":"","src":require("../assets/images/anicomgo_rgb-06.png"),"width":"150"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }